import * as yup from "yup"


const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
function checkIfFilesAreTooBig(files) {
   
    let valid = true
    const filesArray = Array.isArray(files) ? files : [files];
    console.log("filesssss",files)
    if (filesArray) {
        for (const file of filesArray) {
            if (file) {
              const size = file.size / 1024 / 1024;
              if (size > 2) {
                return valid= false;
              }
            }
          }
    }
    return valid
  }
  function checkIfFilesAreCorrectType(files) {
    console.log(files)
    let valid = true
    const filesArray = Array.isArray(files) ? files : [files];
    if (filesArray) {
        filesArray.map(file => {
          
        if (!['jpg', 'jpeg', 'png'].includes(file)) {
          valid = false
        }
      })
    }
    return valid
  }
export const FreeRideOneSchema = yup.object().shape({
    first_name:yup.string().required("First name is required"),
    last_name:yup.string(),
    email:yup.string().required('Email is required').email('Enter valid email'),
})
export const FreeRideTwoSchema = yup.object().shape({
    phone:yup.string().required("Phone is required"),
    patient_name:yup.string().required("Patient name is required"),
})
export const FreeRideThreeSchema = yup.object().shape({
    patient_relation:yup.string().required("Relationship to patient is required"),
    patient_age:yup.string().required("Patient age is required"),
})
export const FreeRideFourSchema = yup.object().shape({
    transport_date:yup.string().required("Transport date is required"),
    street_name:yup.string().required("Street name is required"),
})
export const FreeRideFiveSchema = yup.object().shape({
    city_state:yup.string().required("City and state is required"),
    receiving_facility:yup.string().required("Receiving facility name is required"),
})
export const FreeRideSixSchema = yup.object().shape({
  password:yup.string().required("Password is required").min(8,"Password must be minimum 8 characters"),
  cPassword:yup.string().required("Cofirm passowrd is required").oneOf([yup.ref("password"),null],"Password must match")

})
export const DriveUsOneSchema = yup.object().shape({
    first_name:yup.string().required("First name is required"),
    last_name:yup.string(),
    email:yup.string().required('Email is required').email('Enter valid email'),
    password:yup.string().required("Password is required").min(8,"Password must be minimum 8 characters"),
  cPassword:yup.string().required("Cofirm passowrd is required").oneOf([yup.ref("password"),null],"Password must match")
})
export const DriveUsOne_2Schema = yup.object().shape({
  phone:yup.string().required("Phone is required"),
    address:yup.string().required('Address is required'),
    apt:yup.string().required("Apt, Suite, Unit, Bulding, Floor is required"),
    city:yup.string().required("City is required")
 
})

export const DriveUsTwoSchema = yup.object().shape({
  state:yup.string().required("State is required"),
  zip_code:yup.string().required("Zip code is required"),
  profile_pic: yup.string().required('Profile picture is required'),
  vehicle_pic:yup.string().required('Vehicle picture is required'),
})
export const DriveUsThreeSchema = yup.object().shape({
    driver_license: yup.string().required('Driver license is required'),
    driver_license_expiry:yup.string().required('Driver license expiry is required'),
    driver_license_number: yup.string().required('Driver license number is required'),
    
})
export const DriveUsFourSchema = yup.object().shape({
  tlc_license:yup.string().required('TLC license is required'),
  tlc_license_expiry:yup.string().required('TLC license expiry is required'),
  tlc_license_number:yup.string().required('TLC number is required'),
 
})

export const DriveUsSixSchema = yup.object().shape({
  vehicle_reg_pic: yup.string().required('Vehicle registrition picture is required'),
  vehicle_reg_expiry: yup.string().required('Vehicle registrition expiry is required'),
  vehicle_reg_plate: yup.string().required('Plate number is required'),
  vehicle_reg_pin: yup.string().required('Vin number is required'),
 
})
export const DriveUsEightSchema = yup.object().shape({
 
  diamond_sticker_pic: yup.string().required('Diamond sticker picture is required'),
  diamond_sticker_expiry: yup.string().required('Diamond sticker expiry is required'),
  diamond_sticker_number: yup.string().required('Diamond sticker number is required'),
  
 
})

export const DriveUsTenSchema = yup.object().shape({
  fh1_insurance_pic:yup.string().required('FH-1 insurance picture is required'),
  fh1_insurance_expiry:yup.string().required('FH-1 insurance expiry is required'),
  liability_insurance_pic:yup.string().required('Liability insurance picture is required'),
  liability_insurance_expiry:yup.string().required('Liability insurance expiry is required'),
})
// Car inspection expiry: user can pick any future date, but we clamp to 4th-month end in UI
export const DriveUsElevenSchema = yup.object().shape({
  social_security_pic: yup.string().required('Social security picture is required'),
  social_security_number: yup.string().required('Social security number is required').max(11,"Social security number should be 9 numbers").min(11,"Social security number should be 9 numbers"),
  car_inspec_pic: yup.string().required('Car inspection picture is required'),
  car_inspec_expiry: yup
    .mixed()
    .required('Car inspection expiry is required')
    .test('not-past', 'Car inspection expiry cannot be in the past', function(value) {
      if (!value) return false;
      const selected = value instanceof Date ? value : new Date(value);
      if (isNaN(selected.getTime())) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);
      return selected >= today;
    }),
})

export const PartnerWithUsOneSchema = yup.object().shape({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string(),
  institution_name:yup.string().required('Institution name is required'),
})
export const PartnerWithUsTwoSchema = yup.object().shape({
  email:yup.string().required('Email is required').email('Enter valid email'),
  phone:yup.string().required('Phone is required'),
})
export const PartnerWithUsThreeSchema = yup.object().shape({
  industry:yup.string().required('Industry is required'),
  other_industry:yup.string().required('Other industry is required'),
})
export const PartnerWithUsFourSchema = yup.object().shape({
  city:yup.string().required('City is required'),
  state:yup.string().required('State is required'),
})

export const PartnerWithUsFiveSchema = yup.object().shape({
  password:yup.string().required("Password is required").min(8,"Password must be minimum 8 characters"),
  cPassword:yup.string().required("Confirm passowrd is required").oneOf([yup.ref("password"),null],"Password must match")

})

export const AccountValidation = yup.object().shape({
  first_name:yup.string().required("First name is required"),
  last_name:yup.string(),
  email:yup.string().required("Email is required"),
  phone:yup.string().required("Phone is required"),
  bank_name:yup.string().required("Bank name is required"),
  account_number:yup.string().required("Account number is required"),
  confirm_account_number:yup.string().required("Confirm account number is required").oneOf([yup.ref("account_number"),null],"Account number must match"),
  routing_number:yup.string().required("Routing number is required"),
  dob:yup.string().required("Date of birth is required"),
  // business_profile_mcc:yup.string().required("Business profile mcc is required"),
  address_line1:yup.string().required("Address line 1 is required"),
  city:yup.string().required("City is required"),
  state:yup.string().required("State is required"),
  postal_code:yup.string().required("Postal code is required"),
  ssn_number:yup.string().required("Social security number is required"),
  identity:yup.string().required("Image of identity card is required "),
 

})
